import { useEffect } from "react"
import { useSelector } from "react-redux"
import { RootState } from "@app/types"
import { NativeEventBridge } from "@ng-mw/shared-react-components"
import { useShouldUseNativeTabBar } from "@app/helpers/nativeTabBar/useShouldUseNativeTabBar"
import MenyNativeEvent from "@app/events/MenyNativeEvent"
import { navigateToOptions } from "@app/connectors/history-connectors"

export const useNativeTabBarBadge = () => {
    const appEnv = useSelector((state: RootState) => state.appEnvConfig)
    const totalCartQuantity = useSelector((state: RootState) => state.cart.totals.totalQuantity)
    const shouldUseNativeTabBar = useShouldUseNativeTabBar(appEnv.supportsNativeTabs)

    useEffect(() => {
        if (!shouldUseNativeTabBar) {
            return
        }

        NativeEventBridge.broadcastNative(MenyNativeEvent.TabBarSetBadge, {
            navigateTo: navigateToOptions.KURV,
            count: totalCartQuantity,
        })
    }, [shouldUseNativeTabBar, totalCartQuantity])
}
